// Yeni adresler (domeinApp.nl.ts). Türkçe sürüm.
export const appDomeinTr = {
    company: {
        title: 'Şirket bilgileri',
        kvk: 'Ticaret Odası (KvK) {kvk}',
        contact: 'İletişim',
        where: 'Uygulama {app} adresinde, duvardaki pano {board} adresinde. Yalnızca {app} adresinde oturum aç.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'AMUMIN ana ekranında mıydı? Eski simgeyi sil ve {app} adresini yeniden ana ekranına ekle. iPhone veya iPad’de bildirimler yalnızca ana ekrandan çalışır.',
    push: {
        title: 'Bu tarayıcıda bildirimler kapalı',
        body: 'AMUMIN artık amumin.app adresinde. Bildirimler her adres için ayrı açılır, bu yüzden bu tarayıcıda bir kez daha açılması gerekiyor. Burada yeniden bildirim almak ister misin?',
        action: 'Bildirimleri aç',
        later: 'Şimdi değil',
        done: 'Bildirimler yeniden açık.',
        denied: 'Bu tarayıcı bildirimleri engelliyor. Tarayıcı ayarlarından izin verebilirsin.',
    },
};
//# sourceMappingURL=domeinApp.tr.js.map